import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { BlockNames } from '../block.types';

export function addBlocks(piral: PiletApi) {
	const LazyViewClient = React.lazy(() => import('./SolutionPaywall'));
	piral.registerExtension(BlockNames.SolutionPaywall, props => (
		<React.Suspense
			fallback={
				<div data-testid="loading-view-client" /> /** Customize this loading if you want */
			}
		>
			<LazyViewClient {...props} />
		</React.Suspense>
	));
}
